<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="backdrop-blur"></div>
      <div :style="{height: modalHeight ? modalHeight : '90%', width: modalWidth ? modalWidth : '90%' }" class="modal">
        <header class="modal-header">
          <slot name="header"></slot>
          <button type="button" class="btn-close" @click="close">x</button>
        </header>
        <section class="modal-body">
          <app-perfect-scrollbar style="padding: 20px; height: 100%;" class="modal">
            <slot name="body"></slot>
          </app-perfect-scrollbar>
        </section>
        <footer
          :style="{'justify-content': footerPosition ? footerPosition : 'flex-end'}"
          class="modal-footer"
        >
          <slot name="footer">
            <div style="display: flex;">
              <button
                type="submit"
                class="btn button"
                style="margin-right: 10px; width: 200px"
                @click="close"
              >{{ 'Fechar' }}</button>
              <button
                v-show="!noActionButton"
                type="button"
                class="btn button-gradient"
                style="width: 200px"
                @click="action"
              >{{ btnActionName ? btnActionName : 'Salvar' }}</button>
            </div>
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: [
    "title",
    "btnActionName",
    "noActionButton",
    "modalHeight",
    "modalWidth",
    "footerPosition"
  ],
  methods: {
    close() {
      this.$emit("close");
    },
    action() {
      this.$emit("action");
    }
  }
};
</script>

<style scoped>
@keyframes scale-in {
  0% {
    transform: scale(0.1)
  }

  100% {
    transform: scale(1);
  }
}

.modal-backdrop {
  position: fixed;
  z-index: 2;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-backdrop > .modal {
  animation: scale-in 200ms;
  width: 90%;
  max-width: 960px;
  z-index: 3;
}

.modal {
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  border-radius: 5px;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  color: #c3c5c6 !important;
  justify-content: space-between;
  align-items: center;
  background: #161a1d;
}

.modal-footer {
  background: #23272b;
}

.modal-body {
  position: relative;
  background: #23272b;
  flex-grow: 1;
  height: calc(100% - 118px);
}

.btn-close {
  border: none;
  font-size: 20px;
  cursor: pointer;
  font-weight: bold;
  background: transparent;
  color: #0072e4;
}

.modal-fade-enter,
.modal-fade-leave-active {
  opacity: 0;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.3s ease;
}

.backdrop-blur {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  -webkit-backdrop-filter: blur(2px); /* Safari 9+ */
  backdrop-filter: blur(2px); /* Chrome and Opera */
  z-index: 0;
}
</style>
